// src/components/sveden/Education.js
import { FiDownload } from 'react-icons/fi';

const Education = () => {
  return (
    <div>
      <h2 className="text-2xl font-semibold text-gray-800 mb-4">Образование</h2>
      <p className="mb-4">Дополнительная общеразвивающая программа «Сложные вопросы обществознания».</p>
      <div className="space-y-3">
        <a
          href="/documents/program.pdf"
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-2 text-blue-600 hover:underline"
        >
          <FiDownload />
          Скачать программу (PDF)
        </a>
        <br />
        <a
          href="/documents/program-order.pdf"
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-2 text-blue-600 hover:underline"
        >
          <FiDownload />
          Приказ об утверждении программы (PDF)
        </a>
      </div>
    </div>
  );
};

export default Education;